var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.174 28.1125C13.3098 28.1756 13.46 28.209 13.6094 28.209H13.6154C13.7674 28.2082 13.9199 28.1729 14.056 28.1069C24.8584 22.8961 26.6891 11.6533 26.9925 8.33167C27.0621 7.57323 26.641 6.86694 25.9451 6.57422C23.7947 5.66866 22.3328 3.64363 22.1301 1.28948C22.0675 0.564802 21.457 0 20.7378 0H20.7293L6.17588 0.0866906C5.44218 0.0908186 4.84612 0.656371 4.78988 1.40206C4.6108 3.75697 3.17041 5.79663 1.03073 6.72508C0.341801 7.02381 -0.0688933 7.73385 0.00954569 8.49192C0.351421 11.8098 2.31202 23.0304 13.174 28.1125Z",
    fill: "url(#paint0_linear_7643_17355)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9228 17.1363C13.2435 17.4332 13.7769 17.3732 14.0206 17.0148L18.8202 9.9546C19.0403 9.63099 18.9494 9.19463 18.6174 8.98011C18.2857 8.76595 17.838 8.85454 17.6179 9.17779L13.2927 15.5402L10.8894 13.3159C10.6006 13.0487 10.1442 13.0604 9.86967 13.3419C9.5955 13.6234 9.60751 14.0682 9.89634 14.3355C9.89596 14.3355 12.9201 17.1341 12.9228 17.1363Z",
    fill: "#37C976"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35613 11.9938C3.44198 12.2953 3.84271 12.5713 4.22827 12.47C4.60644 12.3704 4.8303 11.9995 4.72743 11.6384C4.54649 11.0023 4.39441 10.3575 4.2749 9.71861C6.20493 8.51889 7.63728 6.7283 8.33995 4.63698L18.5999 4.57945C19.3281 6.6623 20.7823 8.43735 22.7271 9.6152C22.6158 10.2558 22.4715 10.9028 22.2979 11.5413C22.1995 11.9038 22.4278 12.2737 22.8074 12.3676C23.1878 12.4615 23.5752 12.2437 23.6737 11.8812C23.8772 11.1315 24.0429 10.3705 24.1658 9.61943C24.2346 9.19976 24.0333 8.78714 23.6537 8.5683C21.842 7.52459 20.5029 5.88719 19.8832 3.95788C19.7437 3.52409 19.3148 3.22266 18.839 3.22266H18.8323L8.09056 3.28266C7.61175 3.28548 7.18327 3.59292 7.04895 4.02989C6.45321 5.9659 5.13409 7.61812 3.33541 8.68231C2.95836 8.90503 2.76262 9.31976 2.83625 9.73909C2.96872 10.4884 3.14337 11.247 3.35613 11.9938Z",
    fill: "#37C976"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1312 14.1556C21.7718 14.0057 21.3603 14.1785 21.2118 14.5403C19.5847 18.5109 17.0088 21.5296 13.5535 23.5164C10.0715 21.568 7.45823 18.5748 5.78524 14.6167C5.63268 14.2568 5.21902 14.0891 4.86146 14.2424C4.50354 14.3956 4.33705 14.8121 4.48924 15.1721C6.31516 19.4912 9.19173 22.7473 13.039 24.8492C13.2011 24.9382 13.3786 24.9822 13.5557 24.9822C13.7373 24.9822 13.9184 24.936 14.0834 24.8433C17.9018 22.6986 20.738 19.414 22.5137 15.0809C22.6622 14.719 22.4909 14.3048 22.1312 14.1556Z",
    fill: "#37C976"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7643_17355",
    x1: -2.6194,
    y1: -20.5522,
    x2: 13.5,
    y2: 28.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37C976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570871,
    stopColor: "#161D26"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeComplete);
export default __webpack_public_path__ + "static/media/badgeComplete.bb09bf1839bb5a6ea89f2736f4950610.svg";
export { ForwardRef as ReactComponent };